import React from "react";
import { ScrollArea, Table } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { OKNGainSummaryRow, oknDirectionLabelKey } from "@utils/oknChartData";

interface OKNGainSummaryTableProps {
  rows: OKNGainSummaryRow[];
}

function formatCell(mean: number | null, std: number | null): string {
  if (mean == null) return "—";
  if (std == null) return mean.toFixed(2);
  return `${mean.toFixed(2)} ± ${std.toFixed(2)}`;
}

const OKNGainSummaryTable: React.FC<OKNGainSummaryTableProps> = ({ rows }) => {
  const { t } = useTranslation();

  if (rows.length === 0) return null;

  return (
    <ScrollArea>
      <Table striped highlightOnHover withTableBorder>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>{t("okn.summarySegment")}</Table.Th>
            <Table.Th>{t("okn.summaryLeftEye")}</Table.Th>
            <Table.Th>{t("okn.summaryRightEye")}</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {rows.map((row) => (
            <Table.Tr key={row.segmentIndex}>
              <Table.Td>
                {t("okn.summarySegmentLabel", {
                  direction: t(oknDirectionLabelKey(row.direction)),
                  speed: row.speedDps,
                })}
              </Table.Td>
              <Table.Td>{formatCell(row.leftMean, row.leftStd)}</Table.Td>
              <Table.Td>{formatCell(row.rightMean, row.rightStd)}</Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </ScrollArea>
  );
};

export default React.memo(OKNGainSummaryTable);
